import "./User.css";
import InputCus from "../../Component/InputCus/Text/InputCus";
import { useEffect, useState } from "react";
import Select from "../../Component/InputCus/Select/Select";
import {
  UsersDelete,
  UsersFilter,
  UsersChangeActive,
} from "../../Api/Services";
import imgDelete from "../../assets/Icon/icons8-remove-100.png";
import imgDoc from "../../assets/Icon/icons8-edit-48.png";
import imgIdentity from "../../assets/Icon/icons8-identity-64.png";
import imgIdentityDate from "../../assets/Icon/icons8-date-100.png";
import { confirmAlert } from "react-confirm-alert";
import imgPlus from "../../assets/Icon/pluse.png";
import sync from "../../assets/Icon/icons8-sync-50.png";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

function User() {
  const [Search, setSearch] = useState({});
  const [dataUser, setDataUser] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const navigate = useNavigate();

  const start = async () => {
    try {
      const UsersFilterData = await UsersFilter({});
      if (UsersFilterData.status && UsersFilterData.status === 200) {
        setDataUser(UsersFilterData.data.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const Clear = async () => {
    setSearch({});
    setLoading(true);
    try {
      const UsersFilterData = await UsersFilter({});
      if (UsersFilterData.status && UsersFilterData.status === 200) {
        setDataUser(UsersFilterData.data.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const Searched = async () => {
    try {
      setLoading(true);
      let searching = { ...Search };
      const UsersFilterData = await UsersFilter({ ...searching });
      if (UsersFilterData.status && UsersFilterData.status === 200) {
        setDataUser(UsersFilterData.data.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const confirmDelete = (e) => {
    confirmAlert({
      title: "حذف کاربر",
      message: "آیا مطمئن هستید ؟",
      buttons: [
        {
          label: "بله",
          onClick: () => DeleteItem(e),
        },
        {
          label: "خیر",
        },
      ],
    });
  };

  const confirmUsersChangeActive = (e) => {
    confirmAlert({
      title: "تغییر وضعیت کاربر",
      message: "آیا مطمئن هستید ؟",
      buttons: [
        {
          label: "بله",
          onClick: () => ActiveItem(e),
        },
        {
          label: "خیر",
        },
      ],
    });
  };

  const DeleteItem = async (e) => {
    try {
      setLoading(true);
      const UsersDeleteData = await UsersDelete(e);
      if (UsersDeleteData.status && UsersDeleteData.status === 200) {
        toast.success("عملیات با موفقیت انجام شد");
        await start();
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const ActiveItem = async (e) => {
    try {
      setLoading(true);
      const UsersChangeActiveData = await UsersChangeActive(e);
      if (
        UsersChangeActiveData.status &&
        UsersChangeActiveData.status === 200
      ) {
        toast.success("عملیات با موفقیت انجام شد");
        await start();
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const Add = () => {
    navigate("/Panel/User/Add");
  };

  const Exp = (date) => {
    const targetDate = new Date(date);
    const nowUtc = new Date().getTime();
    const diffMs = targetDate.getTime() - nowUtc;
    const totalMinutes = Math.floor(diffMs / (1000 * 60));
    if (totalMinutes > 0) {
      const days = Math.floor(totalMinutes / (60 * 24));
      const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
      const minutes = totalMinutes % 60;

      return `${days} روز، ${hours} ساعت، ${minutes} دقیقه`;
    } else {
      return 0;
    }
  };

  const ExpRevers = (date) => {
    const targetDate = new Date(date);
    const now = Date.now();

    const diffMs = now - targetDate.getTime(); // برعکس شد
    const totalMinutes = Math.floor(diffMs / (1000 * 60));

    if (totalMinutes > 0) {
      const days = Math.floor(totalMinutes / (60 * 24));
      const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
      const minutes = totalMinutes % 60;

      return `${days} روز، ${hours} ساعت، ${minutes} دقیقه`;
    } else {
      return 0;
    }
  };

  const UserExp = (id) => {
    navigate("/Panel/User/Exp/" + id);
  };

  const Identity = (id) => {
    navigate("/Panel/User/Identity/" + id);
  };

  const IdentityCom = (id) => {
    navigate("/Panel/User/IdentityCom/" + id);
  };

  const Edite = (id) => {
    navigate("/Panel/User/Edite/" + id);
  };

  const handleChangeSearch = (e) => {
    const newSearch = { ...Search };
    newSearch[e.target.id] = e.target.value;
    setSearch(newSearch);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          <div className="d-flex justify-content-start align-items-center w-100 mb-5 pointer">
            <img
              onClick={() => {
                Add();
              }}
              src={imgPlus}
              alt=""
            />
          </div>
          <div className="d-flex justify-content-start align-items-center flex-wrap">
            <InputCus
              type="text"
              name="firstName"
              id="firstName"
              text="نام"
              value={Search.firstName || ""}
              onChange={handleChangeSearch}
              className="m-2"
            />

            <InputCus
              type="text"
              name="lastName"
              id="lastName"
              text="نام خانوادگی"
              value={Search.lastName || ""}
              onChange={handleChangeSearch}
              className="m-2"
            />

            <InputCus
              type="text"
              name="userName"
              id="userName"
              text="شماره موبایل"
              value={Search.userName || ""}
              onChange={handleChangeSearch}
              className="m-2"
            />
            <InputCus
              type="text"
              name="nationalCode"
              id="nationalCode"
              text="کد ملی"
              value={Search.nationalCode || ""}
              onChange={handleChangeSearch}
              className="m-2"
            />
            <InputCus
              type="number"
              name="expDateStart"
              id="expDateStart"
              text="تاریخ اعتبار از"
              value={Search.expDateStart*1 || ""}
              onChange={handleChangeSearch}
              className="m-2"
            />
            <InputCus
              type="number"
              name="expDateEnd"
              id="expDateEnd"
              text="تاریخ اعتبار تا"
              value={Search.expDateEnd*1 || ""}
              onChange={handleChangeSearch}
              className="m-2"
            />

            <Select
              type="text"
              name="isActived"
              id="isActived"
              text="وضعیت"
              value={Search.isActived || ""}
              onChange={handleChangeSearch}
              className="m-2"
              option={[
                { value: true, title: "فعال" },
                { value: false, title: "غیرفعال" },
              ]}
            />
            <Select
              type="text"
              name="Stat"
              id="Stat"
              text="احراز حویت"
              value={Search.Stat || ""}
              onChange={handleChangeSearch}
              className="m-2"
              option={[
                { value: 1, title: "انجام شده" },
                { value: 0, title: "انجام نشده" },
              ]}
            />
          </div>
          <div className="d-flex justify-content-between align-items-center w-100 mb-3">
            <div onClick={Searched} className="btnSearch">
              جست و جو
            </div>
            <div onClick={Clear} className="btnCancel">
              بروزرسانی
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-center w-100 p-2 tableC">
            <table className="table">
              <thead className="sticky-header">
                <tr className="trTable">
                  <th>نام شرکت</th>
                  <th>نام</th>
                  <th>نام خانوادگی</th>
                  <th>شماره موبایل</th>
                  <th>کد ملی</th>
                  <th>زمان استفاده</th>
                  <th>اخرین ورود</th>
                  <th>احراز حویت</th>
                  <th>وضعیت</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {dataUser.map((item, key) => (
                  <tr key={key}>
                    <td>{item.companyName}</td>
                    <td>{item.firstName}</td>
                    <td>{item.lastName}</td>
                    <td>{item.userName}</td>
                    <td>{item.nationalCode}</td>
                    <td>
                      {Exp(item.expDate) == 0 ? (
                        "ندارد"
                      ) : (
                        <div className="d-flex flex-column">
                          <span>{Exp(item.expDate)}</span>
                        </div>
                      )}
                    </td>
                    <td>
                      {ExpRevers(item.createDateToken) == 0 ||
                      item.createDateToken == "0001-01-01T00:00:00" ? (
                        "-"
                      ) : (
                        <div className="d-flex flex-column">
                          <span>{ExpRevers(item.createDateToken)}</span>
                        </div>
                      )}
                    </td>
                    {item.stat == 1 ? (
                      <td className="text-success">انجام شده</td>
                    ) : (
                      <td className="text-danger">انجام نشده</td>
                    )}
                    {item.isActived ? (
                      <td className="text-success">
                        فعال
                        <span
                          className="d-inline-block pointer ms-2"
                          tabIndex="0"
                          data-bs-toggle="tooltip"
                          title="تغییر"
                        >
                          <img
                            height="30"
                            className="me-2"
                            src={sync}
                            alt="تغییر"
                            onClick={() => {
                              confirmUsersChangeActive(item.id);
                            }}
                          />
                        </span>
                      </td>
                    ) : (
                      <td className="text-danger">
                        غیر فعال
                        <span
                          className="d-inline-block pointer ms-2"
                          tabIndex="0"
                          data-bs-toggle="tooltip"
                          title="تغییر"
                        >
                          <img
                            height="30"
                            className="me-2"
                            src={sync}
                            alt="تغییر"
                            onClick={() => {
                              confirmUsersChangeActive(item.id);
                            }}
                          />
                        </span>
                      </td>
                    )}
                    <td className="td-actions">
                      <span
                        className="d-inline-block pointer ms-2"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="حذف"
                      >
                        <img
                          height="30"
                          className="me-2"
                          src={imgDelete}
                          alt="حذف"
                          onClick={() => {
                            confirmDelete(item.id);
                          }}
                        />
                      </span>
                      <span
                        className="d-inline-block pointer"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="ویرایش"
                      >
                        <img
                          height="30"
                          src={imgDoc}
                          alt="ویرایش"
                          onClick={() => {
                            Edite(item.id);
                          }}
                        />
                      </span>
                      <span
                        className="d-inline-block pointer m-2"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="دسترسی"
                      >
                        <img
                          height="40"
                          src={imgIdentity}
                          alt="دسترسی"
                          onClick={() => {
                            Identity(item.id);
                          }}
                        />
                      </span>

                      <span
                        className="d-inline-block pointer m-2"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="دسترسی تاریخ"
                      >
                        <img
                          height="40"
                          src={imgIdentityDate}
                          alt="دسترسی تاریخ"
                          onClick={() => {
                            UserExp(item.id);
                          }}
                        />
                      </span>
                      <span
                        className="d-inline-block pointer m-2"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title=" دسترسی به مراجع"
                      >
                        <img
                          height="40"
                          src={imgIdentity}
                          alt="دسترسی به مراجه"
                          onClick={() => {
                            IdentityCom(item.id);
                          }}
                        />
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default User;
